export { addAuthCategoryToCognitoUserAgent, addFrameworkToCognitoUserAgent } from '../UserAgent';


//////////////////
// WEBPACK FOOTER
// ./node_modules/amazon-cognito-identity-js/es/internals/index.js
// module id = 8p0J
// module chunks = 0